<template lang="pug">
div
  UiCardSection
    UiStack(vertical)
      UiStack
        UiStackItem(fill)
          .ui-card-section-title {{ $t("companies.tabs.storages") }}
      .form-container
        UiStack(vertical)
          UiStack(
            vertical
            spacing="xs"
          )
            strong {{ $t("companies.storages.drive.title") }}
            a(
              :href="googleDriveLink"
              v-if="!drive.enabled"
            ) {{ $t("companies.storages.drive.connect") }}
          UiStack(v-if="drive.enabled")
            UiStackItem(fill)
              UiInput(
                v-model="driveSelectedFolderName"
                :readonly="true"
              )
            UiStackItem
              UiButton(
                :disabled="drive.root_folder_id === driveSelectedFolder"
                variant="primary"
                @click="saveDriveFolder"
                icon="Folder"
              ) {{ $t("actions.save") }}
          UiMultiselect(
            v-model="driveSelectedFolder"
            v-if="drive.enabled"
            :disabled="driveFiles.length == 0"
            :options="driveFiles"
            :select-size="driveFiles.length"
            :canDeselect="false"
            :canClear="false"
            label="text"
          )
  UiCardSection
    UiStack
      UiStackItem(fill)
      UiStackItem
        UiButton(
          variant="primary"
          @click="addSftp()"
          icon="Plus"
        ) {{ $t("actions.add") }}
  UiCardSection
    RestTable(
      namespace="company_storages"
      :headers="headers"
      ref="companyStoragesTable"
      :fetch-handler="getStorages"
      :disablePagination="true"
      embed
    )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="showErrors(item)"
            v-if="item.has_errors"
            icon="AlertTriangle"
          ) {{ $t("companies.softwares.show_errors") }}
          UiButton(
            size="sm"
            variant="smooth-primary"
            @click="editSFTP(item)"
            icon="PencilCreate"
          ) {{ $t("actions.edit") }}
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="deleteSFTP(item)"
            icon="Trash"
          ) {{ $t("actions.delete") }}
      template(#cell:default="{ item }")
        UiButton(
          size="sm"
          :variant="STORAGES[item.default] || 'false'"
        ) {{ item.default == true ? $t("companies.storages.sftp.reports") : "" }}
  EditSftpModal(
    ref="EditSftpModal"
    @done="reloadList"
  )
</template>

<script>
import ApiCompanyStorages from "@/api/companyStorages.js";
import EditSftpModal from "@/modals/Companies/updateSftp.vue";

const STORAGES = {
  true: "success",
  false: "",
};

export default {
  components: {
    EditSftpModal,
  },

  data() {
    return {
      STORAGES: STORAGES,
      drive: {},
      driveSelectedFolder: null,
      driveFiles: [],
      headers: [
        {
          key: "id",
          label: "ID",
          squeeze: true,
        },
        {
          key: "name",
          label: "Name",
          squeeze: false,
        },
        {
          key: "host",
          label: "Host",
          squeeze: false,
        },
        {
          key: "port",
          label: "Port",
          squeeze: false,
        },
        {
          key: "remote_path",
          label: "Folder",
          squeeze: false,
        },
        {
          key: "default",
          label: "Reports",
          squeeze: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  watch: {
    sftpSelectedFolder: function (value) {
      this.changeSelectedSFTPFolder(value);
    },
  },

  computed: {
    googleDriveLink() {
      return `/auth/${this.$route.params.id}`;
    },

    driveSelectedFolderName() {
      if (!this.driveSelectedFolder) {
        return "";
      }
      if (!this.driveFiles) {
        return "";
      }
      return this.driveFiles.find((a) => a.value === this.driveSelectedFolder)
        .text;
    },
  },

  methods: {
    reloadList() {
      this.$refs.companyStoragesTable.fetchData();
    },

    getStorages(params, config) {
      return ApiCompanyStorages.fetchStorages(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.sftp,
          meta: resp.data.meta,
        };
      });
    },

    addSftp() {
      this.$refs.EditSftpModal.open(this.$route.params.id, null);
    },

    editSFTP(item) {
      this.$refs.EditSftpModal.open(this.$route.params.id, item);
    },

    deleteSFTP(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "lan-disconnect",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanyStorages.deleteSFTP(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },

    //Google drive stuff
    getDrive() {
      return new Promise((res) => {
        ApiCompanyStorages.fetchDrive(this.$route.params.id).then((resp) => {
          this.drive = resp.data.drive;
        });
      });
    },
  },

  mounted() {
    this.getDrive();
  },
};
</script>
